import { createIcon } from '../createIcon';
import { ReactComponent as IconTrashAlt } from '../svg/trash-alt.svg';

export default createIcon(IconTrashAlt);
